module.exports = __webpack_public_path__ + "img/desc2.0f7a0978.png";